/**
 * Created by bartdecorte on 04/05/2017.
 */
import Swal from 'sweetalert2';

class Slug {
  constructor(params) {
    this.params = {
      $element: params.$element,
    };
    this.bindListeners();
  }

  bindListeners() {
    this.params.$element.on('click', 'a', (ev) => {
      return this.lButtonClicked(ev);
    });
  }

  lButtonClicked(ev) {
    ev.preventDefault();
    let $elt = $(ev.target).is('a') ? $(ev.target) : $(ev.target).first();
    this.confirm(() => {
      this.enable();
    });
    return false;
  }

  confirm(cb) {
    Swal.fire({
      title: 'Are you sure?',
      text:
        'Be careful, changing a slug will break the previous URL. If this URL was already published somewhere, ' +
        'it will no longer be accessible. If you want to generate a new slug automatically, leave this field blank.',
      icon: 'warning',
      showCancelButton: true,
      customClass: {
        confirmButton: 'btn ml-1 mr-1 btn-warning',
        cancelButton: 'btn ml-1 mr-1 btn-light',
      },
      closeOnConfirm: true,
      buttonsStyling: false,
    }).then(({ isConfirmed, isDismissed }) => {
      if (isConfirmed) {
        cb();
      }
    });
  }

  enable() {
    let $input = this.params.$element.find('.js-column-value').first();
    let $button = this.params.$element.find('a').first();
    $button.addClass('disabled');
    $input.removeAttr('readonly', false);
    $input
      .parent()
      .find('.js-column-touched')
      .val(1);
  }
}

export default Slug;



// WEBPACK FOOTER //
// ./resources/assets/js/utils/Slug.js